import { Form, FormInstance, Input } from 'antd';
import React, { memo } from 'react';
import { languages, ruLangLabels } from '../../admin-knowledge-base.constants';
import { KBEntity } from '../../admin-knowledge-base.type';
import { Languages } from '/react4xp/parts/knowledge-base-common/knowledge-base-common.type';

interface TitleFieldProps {
    activeLanguage: Languages;
    form: FormInstance<KBEntity>;
    maxLength?: number;
    minLength?: number;
}

const TITLE = 'title';
const DRAFT = 'draft';

const TitleField = memo(
    ({ activeLanguage, form, maxLength = 255, minLength = 0 }: TitleFieldProps) => {
        const handleSaveDraft = () => {
            const draftValue = form.getFieldValue([DRAFT, TITLE])?.trim();
            form.setFieldValue([activeLanguage, TITLE], draftValue);
        };

        return (
            <>
                {languages.map((language) => (
                    <Form.Item
                        hidden
                        key={language}
                        name={[language, TITLE]}
                        validateStatus="success"
                    />
                ))}
                <Form.Item
                    label="Наименование"
                    labelCol={{ span: 24 }}
                    name={[DRAFT, TITLE]}
                    rules={[
                        {
                            validator: () => {
                                const missingField = languages.find(
                                    (language) => !form.getFieldValue([language, TITLE])?.trim()
                                );
                                if (missingField) {
                                    return Promise.reject(
                                        `Не заполнено название (${ruLangLabels[missingField]})`
                                    );
                                }

                                const lengthExceeded = languages.find(
                                    (language) =>
                                        form.getFieldValue([language, TITLE])?.trim().length >
                                        maxLength
                                );
                                if (lengthExceeded) {
                                    return Promise.reject(
                                        `Длина заголовка превышает ${maxLength} символов (${ruLangLabels[lengthExceeded]})`
                                    );
                                }

                                const lengthBelowMinimum = languages.find(
                                    (language) =>
                                        form.getFieldValue([language, TITLE])?.trim().length <
                                        minLength
                                );
                                if (lengthBelowMinimum) {
                                    return Promise.reject(
                                        `Длина заголовка короче ${minLength} символов (${ruLangLabels[lengthBelowMinimum]})`
                                    );
                                }

                                return Promise.resolve();
                            },
                        },
                    ]}
                >
                    <Input onBlur={handleSaveDraft} />
                </Form.Item>
            </>
        );
    }
);

export default TitleField;
